export const findNearestOffice = (serviceId, officeId, catalog) => {
  let mfcs = [];

  catalog.find(({ catalog: subCatalogs }) =>
    subCatalogs.find(({ services }) =>
      services.find((service) => {
        if (service.id === serviceId) {
          mfcs = service.mfcs.slice(0, 2);
        }

        return service.id === serviceId;
      })
    )
  );
  return mfcs[0] === officeId ? mfcs[1] : mfcs[0];
};
